/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, message, Typography } from 'antd';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import Compress from 'react-image-file-resizer';
import BoxImage from '../../../../components/BoxImage';
import { errorHandler, heicAndheifConvert, isMobile } from '../../../../utils';
import { instanceRef } from '../../../../utils/axios';

export default function AmpliacionTarjeta({
  imagen,
  count,
  next,
  ampliacion,
  card
}) {
  const [imagenLocal, setImagenLocal] = useState(imagen);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [latitud, setLatitud] = useState(0.0);
  const [longitud, setLongitud] = useState(0.0);

  useEffect(() => {
    getPosition();
  }, []);

  function uploadAmpView(file, pasoNro, ampliacionParam, parte) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append(
        'empresa',
        ampliacionParam.inspeccion.solicitud.cotizacion.aseguradoraEmpresa
          .empresa.nombre
      );
      formData.append(
        'aseguradora',
        ampliacionParam.inspeccion.solicitud.cotizacion.aseguradoraEmpresa
          .aseguradora.descripcion
      );
      formData.append(
        'nombres',
        `${ampliacionParam.inspeccion?.solicitud?.cotizacion?.persona.nombres} ${ampliacion.inspeccion?.solicitud?.cotizacion?.persona.apellidos}`
      );
      formData.append(
        'chapa',
        ampliacionParam.inspeccion?.solicitud?.cotizacion?.vehiculo.chapa
      );
      formData.append('token', ampliacionParam.token);
      formData.append('paso_nro', pasoNro);
      formData.append('latitud', latitud);
      formData.append('longitud', longitud);
      formData.append('type', 'a');
      formData.append('imgcompress', true);
      formData.append('parte', parte);
      const today = new Date();
      formData.append('fecha', moment(today, 'DD-MM-YYYY'));
      const response = instanceRef.instance.post(
        `archivos/imgcompress`,
        formData,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      return response;
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      return false;
    }
  }

  const uploadFile = async (file, pasoNro, ampliacionParam, parte) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append(
        'empresa',
        ampliacionParam.inspeccion.solicitud.cotizacion.aseguradoraEmpresa
          .empresa.nombre
      );
      formData.append(
        'aseguradora',
        ampliacionParam.inspeccion.solicitud.cotizacion.aseguradoraEmpresa
          .aseguradora.descripcion
      );
      formData.append(
        'nombres',
        `${ampliacionParam.inspeccion?.solicitud?.cotizacion?.persona.nombres} ${ampliacion.inspeccion?.solicitud?.cotizacion?.persona.apellidos}`
      );
      formData.append(
        'chapa',
        ampliacionParam.inspeccion?.solicitud?.cotizacion?.vehiculo.chapa
      );
      formData.append('token', ampliacionParam.token);
      formData.append('paso_nro', pasoNro);
      formData.append('latitud', latitud);
      formData.append('longitud', longitud);
      formData.append('type', 'a');
      formData.append('imgcompress', false);
      formData.append('parte', parte);
      const today = new Date();
      formData.append('fecha', moment(today, 'DD-MM-YYYY'));
      await instanceRef.instance.post(`archivos/upload`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      Compress.imageFileResizer(
        file, // the file from input
        480, // width
        480, // height
        'JPEG', // compress format WEBP, JPEG, PNG
        70, // quality
        0, // rotation
        (uri) => {
          uploadAmpView(uri, pasoNro, ampliacionParam, parte);
        },
        'blob' // blob or base64 default base64
      );
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
    }
  };

  const siguiente = async () => {
    setImagenLocal(null);
    setDisabled(true);
    next(count);
  };

  const getPosition = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(function test(position) {
        setLatitud(position.coords.latitude);
        setLongitud(position.coords.longitude);
      });
    }
  };

  const saveimage = async (file) => {
    try {
      if (isMobile) {
        setLoading(true);
        await uploadFile(file, card.key, ampliacion, card.parte);
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagenLocal(reader.result);
          setDisabled(false);
        };
        setLoading(false);
        reader.readAsDataURL(file);
      } else {
        errorHandler(null, 'Debe tomar la foto desde un dispositivo móvil');
      }
    } catch (err) {
      // error
    }
  };

  const customRequest = async ({ file }) => {
    const converted = await heicAndheifConvert(file);
    try {
      Compress.imageFileResizer(
        converted, // the file from input
        2400, // width
        1600, // height
        'JPEG', // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
          saveimage(uri);
        },
        'blob' // blob or base64 default base64
      );
    } catch (error) {
      message.error(error);
    }
  };

  const getMessage = () => {
    if (disabled) {
      return (
        <Typography.Paragraph style={{ paddingTop: 32 }}>
          Click en la imagen para tomar la fotografía
        </Typography.Paragraph>
      );
    }
    return null;
  };
  return (
    <>
      <BoxImage
        customRequest={customRequest}
        imagen={imagenLocal || card.image}
        loading={loading}
        card={card}
      />
      <Button disabled={disabled} onClick={() => siguiente()}>
        Siguiente
      </Button>
      {getMessage()}
    </>
  );
}
